import { useEffect } from 'react';
import { useWizard } from '@zillow/zrs-rental-applications';
import { useIdVerificationCallbacks } from '../contexts/IdVerificationContext';
import type { FormApi } from 'final-form';

export function useNotifyOnStepChange() {
  const { currentStep, currentSubStep } = useWizard();
  const { onStepChange, onError } = useIdVerificationCallbacks();
  useEffect(() => {
    // first call is null
    if (currentStep) {
      onStepChange({ step: currentStep });
    }
    if (currentStep === 'error') {
      onError({ code: currentSubStep });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Ignoring callbacks
  }, [currentStep, currentSubStep]);
}

/**
 * React final form doesn't reject upon attempting form submission while still in an invalid state.
 * The Wizard library relies upon a rejected promise to avoid navigation, so this method changes that
 * behaviour to throw an error when the form is invalid, so the Wizard library knows not to navigate.
 * @param {import('final-form').FormApi} form
 */
export function getWizardOnSubmit(form: FormApi<Record<string, unknown>>) {
  return async () => {
    await form.submit();

    // never made the request in the first place, validation errors
    // We still want to "attempt" the submit though, so all fields show the errors
    if (form.getState().submitFailed) {
      throw new Error('submit failed');
    }
  };
}
